import { render, staticRenderFns } from "./banner_config.vue?vue&type=template&id=4b99dede&scoped=true&"
import script from "./banner_config.vue?vue&type=script&lang=js&"
export * from "./banner_config.vue?vue&type=script&lang=js&"
import style0 from "./banner_config.vue?vue&type=style&index=0&id=4b99dede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b99dede",
  null
  
)

export default component.exports